import React, { useEffect, useState } from "react";
import {
  Button,
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Typography,
  Grid,
  Box,
  Stack,
  Card,
  Radio,
  Chip,
  Checkbox,
  FormControlLabel,
  RadioGroup,
} from "@mui/material";
import { Icon } from "@iconify/react";
import ImageView from "../UserFormTemplate/component/ImageView";
import MultipleChoiceOptions from "../UserFormTemplate/component/MultipleChoiceOptions";
import CustomConfirmation from "src/components/ModalPopover/Confirmation";
import EditWorkBookQue from "./EditWorkBookQue";
import AvatarGalleryPreview from "src/components/imageViewOnLengthPreview";

export default function QuestionAddOrUpdate({
  questionsToSend,
  setQuestionsToSend,
  editShow,
  setEditShow,
  is_show_only,
  editData,
}) {
  const [multipleChoiceOptions, setMultipleChoiceOptions] = useState(["", ""]);
  const [rating, setRating] = useState(4);
  const [maximumRating, setMaximumRating] = useState("");
  const [minimumRating, setMinimumRating] = useState("");
  const [openDelete, setOpenDelete] = useState(false);
  const [deleteData, setDeleteData] = useState("");
  const [answerGeniusTitle, setAnswerGeniusTitle] = useState("");
  const [saveTemplate, setSaveTemplate] = useState(true);

  const [inputs, setInputs] = React.useState({
    question_type: "multiple_choice",
    question_statement: "",
    question_type_required: false,
    button_link: "",
    button_text: "",
  });
  const answerGenius = [
    {
      title: "Agree-Disagree",
      data: ["Strongly agree", "Agree", "Disagree", "Strongly disagree"],
    },
    {
      title: "Exceeds-Meets",
      data: ["Exceeds", "Meets", "Need Improvement"],
    },
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (inputs.question_type == "multiple_choice") {
      const updatedList = [...questionsToSend];
      updatedList.push({
        title: inputs.question_statement,
        required: inputs.question_type_required,
        order: 1,
        type: inputs.question_type,
        options: multipleChoiceOptions,
        options_count: multipleChoiceOptions.length,
      });
      editShow.push({ display: false });
      setQuestionsToSend(updatedList);
      setInputs((inputs) => {
        return {
          ...inputs,
          ["question_type"]: "multiple_choice",
          ["question_statement"]: "",
          ["question_type_required"]: false,
        };
      });
      setMultipleChoiceOptions(["", ""]);
    }
    if (inputs.question_type == "multiple_select") {
      const updatedList = [...questionsToSend];
      updatedList.push({
        title: inputs.question_statement,
        required: inputs.question_type_required,
        order: 1,
        type: inputs.question_type,
        options: multipleChoiceOptions,
        options_count: multipleChoiceOptions.length,
      });
      editShow.push({ display: false });
      setQuestionsToSend(updatedList);
      setInputs((inputs) => {
        return {
          ...inputs,
          ["question_type"]: "multiple_choice",
          ["question_statement"]: "",
          ["question_type_required"]: false,
        };
      });
      setMultipleChoiceOptions(["", ""]);
    }
    if (inputs.question_type == "image") {
      const updatedList = [...questionsToSend];
      updatedList.push({
        title: inputs.question_statement,
        required: inputs.question_type_required,
        order: 1,
        type: inputs.question_type,
        options: [minimumRating, maximumRating],
        options_count: parseInt(rating),
      });
      editShow.push({ display: false });
      setQuestionsToSend(updatedList);
      setInputs((inputs) => {
        return {
          ...inputs,
          ["question_type"]: "multiple_choice",
          ["question_statement"]: "",
          ["question_type_required"]: false,
        };
      });
      setMinimumRating("");
      setMaximumRating("");
    }
    if (inputs.question_type == "free_text") {
      const updatedList = [...questionsToSend];
      updatedList.push({
        title: inputs.question_statement,
        required: inputs.question_type_required,
        order: 1,
        type: inputs.question_type,
        options: [],
        options_count: 0,
      });
      editShow.push({ display: false });
      setQuestionsToSend(updatedList);
      setInputs((inputs) => {
        return {
          ...inputs,
          ["question_type"]: "multiple_choice",
          ["question_statement"]: "",
          ["question_type_required"]: false,
        };
      });
    }
    if (inputs.question_type == "signature") {
      const updatedList = [...questionsToSend];
      updatedList.push({
        title: inputs.question_statement,
        required: inputs.question_type_required,
        order: 1,
        type: inputs.question_type,
        options: [],
        options_count: 0,
      });
      editShow.push({ display: false });
      setQuestionsToSend(updatedList);
      setInputs((inputs) => {
        return {
          ...inputs,
          ["question_type"]: "multiple_choice",
          ["question_statement"]: "",
          ["question_type_required"]: false,
        };
      });
    }
    if (inputs.question_type == "text_with_link") {
      const updatedList = [...questionsToSend];
      updatedList.push({
        title: inputs.question_statement,
        required: inputs.question_type_required,
        order: 1,
        type: inputs.question_type,
        button_text: inputs.button_text,
        button_link: inputs.button_link,
        options: [],
        options_count: 0,
      });
      editShow.push({ display: false });
      setQuestionsToSend(updatedList);
      setInputs((inputs) => {
        return {
          ...inputs,
          ["question_type"]: "multiple_choice",
          ["question_statement"]: "",
          ["question_type_required"]: false,
          ["button_link"]: "",
          ["button_text"]: "",
        };
      });
    }
    setAnswerGeniusTitle("");
    setSaveTemplate(true);
  };

  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  const handleChangeInMultipleChoice = (e, index) => {
    if (e.target.value[0] === " ") {
      return;
    }
    multipleChoiceOptions[index] = e.target.value;
    setMultipleChoiceOptions([...multipleChoiceOptions]);
  };
  const handelAddChoice = (index) => {
    let list = multipleChoiceOptions;
    list.splice(index + 1, 0, "");
    setMultipleChoiceOptions([...list]);
  };

  const handelDelChoice = (index) => {
    if (multipleChoiceOptions.length === 2) {
      return;
    }
    let list = multipleChoiceOptions;
    list.splice(index, 1);
    setMultipleChoiceOptions([...list]);
  };

  const handelDelQuestion = () => {
    let index = deleteData;
    let list = questionsToSend;
    let list2 = editShow;
    list2.splice(index, 1);
    list.splice(index, 1);
    setEditShow([...list2]);
    setQuestionsToSend([...list]);
    setOpenDelete(false);
  };

  const handleAgreeDelete = (value) => {
    setDeleteData(value);
    setOpenDelete(true);
  };

  const handelEditQuestions = (index) => {
    editShow[index].display = true;
    setEditShow([...editShow]);
    setSaveTemplate(true);
  };

  const handelcloseQuestionsEntry = () => {
    setInputs((values) => ({
      ...values,
      ["question_type"]: "multiple_choice",
      ["question_statement"]: "",
    }));
    setMinimumRating("");
    setMaximumRating("");
    setMultipleChoiceOptions(["", ""]);
    setAnswerGeniusTitle("");
    setRating("");
    setSaveTemplate(true);
  };

  const handleChangeAnswerGenius = (event) => {
    setAnswerGeniusTitle(event.target.value);
    answerGenius.filter((ans) => {
      if (ans.title == event.target.value) {
        setMultipleChoiceOptions(ans.data);
      }
    });
  };

  useEffect(() => {
    if (!editData) {
      setQuestionsToSend([]);
      setSaveTemplate(true);
    }
  }, [editData]);

  console.log(questionsToSend, "questionsToSendquestionsToSendquestionsToSend");

  return (
    <div className="mt-4">
      <CustomConfirmation
        openDelete={openDelete}
        setOpenDelete={setOpenDelete}
        title={"Are you sure you want to delete ?"}
        handleAgree={handelDelQuestion}
      />
      <>
        <Stack
          direction="column"
          alignItems="center"
          spacing={1.5}
          justifyContent="space-between"
          mb={4.5}
        >
          {questionsToSend &&
            questionsToSend.map((item, index) => {
              return !editShow[index].display ? (
                <Card
                  className="w-100"
                  sx={{
                    boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
                    mb: 1,
                    width: { sm: "100%", md: "100%" },
                    margin: "auto",
                    p: 2,
                    backgroundColor: "#f5f5f2",
                    position: "relative",
                  }}
                >
                  {item.required && (
                    <Chip
                      label={"Required"}
                      variant="contained"
                      color={"error"}
                      sx={{
                        fontSize: "10px",
                        height: "auto",
                        width: "auto",
                        position: "absolute",
                        top: 8,
                        left: 16,
                      }}
                    />
                  )}
                  <Box sx={{ width: "100%", margin: "auto" }} margin={0}>
                    <Grid
                      container
                      rowSpacing={0}
                      columnSpacing={{ xs: 0, sm: 0, md: 2 }}
                      mt={1}
                    >
                      <Grid item md={12} xs={12}>
                        <div className=" "></div>
                        <div className="d-flex align-items-center mb-2">
                          <div className="">
                            <Typography
                              sx={{ fontWeight: "900", fontSize: 16, mr: 1 }}
                            >
                              Q{index + 1}.
                            </Typography>
                          </div>
                          <div>
                            <Typography
                              variant="body1"
                              sx={{ fontSize: 14, mr: 1 }}
                            >
                              {item?.title}
                            </Typography>
                          </div>
                        </div>
                      </Grid>
                      {item?.type == "multiple_choice" ? (
                        <Grid item md={12} xs={12}>
                          <FormControl>
                            <RadioGroup
                              aria-labelledby="demo-controlled-radio-buttons-group"
                              name="controlled-radio-buttons-group"
                              value={item?.answer}
                            >
                              {item?.options.map((item) => {
                                return (
                                  <Grid item md={12}>
                                    <FormControlLabel
                                      value={item}
                                      disabled
                                      control={
                                        <Radio
                                          sx={{
                                            "&.Mui-disabled": {
                                              color: "#919eabcc",
                                            },
                                            "&.Mui-checked": {
                                              color: "#04abbb",
                                            },
                                          }}
                                        />
                                      }
                                      label={
                                        <span style={{ color: "#212B36" }}>
                                          {item}
                                        </span>
                                      }
                                    />
                                  </Grid>
                                );
                              })}{" "}
                            </RadioGroup>
                          </FormControl>
                          {!is_show_only && (
                            <div className="w-100 mt-2 d-flex justify-content-end">
                              <Button
                                type="button"
                                variant="outlined"
                                sx={{ mr: 1 }}
                                onClick={() => {
                                  handelEditQuestions(index);
                                }}
                              >
                                Edit
                              </Button>
                              <Button
                                type="button"
                                variant="outlined"
                                color="error"
                                onClick={() => {
                                  handleAgreeDelete(index);
                                }}
                              >
                                Delete
                              </Button>
                            </div>
                          )}
                        </Grid>
                      ) : item?.type == "multiple_select" ? (
                        <Grid item md={12} xs={12}>
                          {item?.options.map((item) => {
                            return (
                              <Grid item md={12}>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      sx={{
                                        "&.Mui-disabled": {
                                          color: "#919eabcc",
                                        },
                                        "&.Mui-checked": {
                                          color: "#04abbb",
                                        },
                                      }}
                                      disabled
                                      checked={questionsToSend[
                                        index
                                      ]?.multiple_answers?.includes(item)}
                                    />
                                  }
                                  label={
                                    <span style={{ color: "#212B36" }}>
                                      {item}
                                    </span>
                                  }
                                />
                              </Grid>
                            );
                          })}
                          {!is_show_only && (
                            <div className="w-100 mt-2 d-flex justify-content-end">
                              <Button
                                type="button"
                                variant="outlined"
                                sx={{ mr: 1 }}
                                onClick={() => {
                                  handelEditQuestions(index);
                                }}
                              >
                                Edit
                              </Button>
                              <Button
                                type="button"
                                variant="outlined"
                                color="error"
                                onClick={() => {
                                  handleAgreeDelete(index);
                                }}
                              >
                                Delete
                              </Button>
                            </div>
                          )}
                        </Grid>
                      ) : item?.type == "image" ? (
                        <Grid item md={12} xs={12}>
                          <div className="d-flex align-items-center mb-2">
                            <div className="">
                              <Typography
                                sx={{
                                  fontWeight: "500",
                                  fontSize: 14,
                                  mr: 1,
                                }}
                              >
                                {item?.options[0]}
                              </Typography>
                            </div>
                            <AvatarGalleryPreview
                              length={item?.options_count}
                              Index={index}
                              questions={questionsToSend}
                              Image={item?.multiple_answers || []}
                              setQuestions={setQuestionsToSend}
                            />
                          </div>
                          {!is_show_only && (
                            <div className="w-100 mt-2 d-flex justify-content-end">
                              <Button
                                type="button"
                                variant="outlined"
                                sx={{ mr: 1 }}
                                onClick={() => {
                                  handelEditQuestions(index);
                                }}
                              >
                                Edit
                              </Button>
                              <Button
                                type="button"
                                variant="outlined"
                                color="error"
                                onClick={() => {
                                  handleAgreeDelete(index);
                                }}
                              >
                                Delete
                              </Button>
                            </div>
                          )}
                        </Grid>
                      ) : item?.type == "free_text" ? (
                        <Grid item md={12} xs={12}>
                          <TextField
                            id="outlined-multiline-static"
                            label="Answer"
                            multiline
                            value={item?.answer}
                            disabled
                            rows={4}
                            sx={{ width: "100%" }}
                          />
                          {!is_show_only && (
                            <div className="w-100 mt-2 d-flex justify-content-end">
                              <Button
                                type="button"
                                variant="outlined"
                                sx={{ mr: 1 }}
                                onClick={() => {
                                  handelEditQuestions(index);
                                }}
                              >
                                Edit
                              </Button>{" "}
                              <Button
                                type="button"
                                variant="outlined"
                                color="error"
                                onClick={() => {
                                  handleAgreeDelete(index);
                                }}
                              >
                                Delete
                              </Button>
                            </div>
                          )}
                        </Grid>
                      ) : item?.type === "text_with_link" ? (
                        <>
                          <Grid item md={6}>
                            <TextField
                              id="outlined-basic"
                              label="Button Text"
                              variant="outlined"
                              className="mt-3"
                              sx={{ width: "100%" }}
                              required
                              disabled
                              name="button_text"
                              value={item.button_text}
                            />
                          </Grid>
                          <Grid item md={6}>
                            <TextField
                              id="outlined-basic"
                              label="Button Link"
                              variant="outlined"
                              className="mt-3"
                              sx={{ width: "100%" }}
                              required
                              disabled
                              name="button_link"
                              value={item.button_link}
                            />
                          </Grid>
                          <Grid item md={12} xs={12}>
                            <TextField
                              id="outlined-multiline-static"
                              label="Answer"
                              multiline
                              value={item?.answer}
                              disabled
                              className="mt-3"
                              rows={4}
                              sx={{ width: "100%" }}
                            />
                          </Grid>
                          {!is_show_only && (
                            <div className="w-100 mt-2 d-flex justify-content-end">
                              <Button
                                type="button"
                                variant="outlined"
                                sx={{ mr: 1 }}
                                onClick={() => {
                                  handelEditQuestions(index);
                                }}
                              >
                                Edit
                              </Button>{" "}
                              <Button
                                type="button"
                                variant="outlined"
                                color="error"
                                onClick={() => {
                                  handleAgreeDelete(index);
                                }}
                              >
                                Delete
                              </Button>
                            </div>
                          )}
                        </>
                      ) : (
                        item?.type == "signature" && (
                          <>
                            {item?.answer ? (
                              <img
                                key={index}
                                src={item?.answer}
                                alt={`Signature ${index + 1}`}
                              />
                            ) : (
                              <Grid item md={12} xs={12}>
                                <TextField
                                  id="outlined-multiline-static"
                                  multiline
                                  disabled
                                  rows={4}
                                  sx={{
                                    width: "100%",
                                    "& fieldset": {
                                      top: 0,
                                    },
                                    "& legend": {
                                      display: "none",
                                    },
                                  }}
                                />
                              </Grid>
                            )}
                            {!is_show_only && (
                              <div className="w-100 mt-2 d-flex justify-content-end">
                                <Button
                                  type="button"
                                  variant="outlined"
                                  sx={{ mr: 1 }}
                                  onClick={() => {
                                    handelEditQuestions(index);
                                  }}
                                >
                                  Edit
                                </Button>{" "}
                                <Button
                                  type="button"
                                  variant="outlined"
                                  color="error"
                                  onClick={() => {
                                    handleAgreeDelete(index);
                                  }}
                                >
                                  Delete
                                </Button>
                              </div>
                            )}
                          </>
                        )
                      )}
                    </Grid>
                  </Box>
                </Card>
              ) : (
                <EditWorkBookQue
                  questionsToSend={questionsToSend}
                  index={index}
                  answerGenius={answerGenius}
                  setQuestionsToSend={setQuestionsToSend}
                  editShow={editShow}
                  setEditShow={setEditShow}
                />
              );
            })}
          {!is_show_only && (
            <>
              {!saveTemplate ? (
                <Card
                  className="w-100"
                  sx={{
                    boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
                    mb: 1,
                    width: { sm: "100%", md: "100%" },
                    margin: "auto",
                    p: 2,
                  }}
                >
                  <form onSubmit={handleSubmit} autoComplete="off">
                    <Box sx={{ width: "100%", margin: "auto" }} margin={0}>
                      <Grid
                        container
                        rowSpacing={2}
                        columnSpacing={{ xs: 0, sm: 0, md: 2 }}
                        mt={1}
                      >
                        <Grid item md={12} xs={12}>
                          <TextField
                            id="outlined-basic"
                            label="Question Statement"
                            variant="outlined"
                            sx={{ width: "100%" }}
                            required
                            name="question_statement"
                            value={inputs.question_statement}
                            onChange={(event) => {
                              if (event.target.value[0] === " ") {
                                return;
                              }
                              setInputs((values) => ({
                                ...values,
                                [event.target.name]: event.target.value,
                              }));
                            }}
                          />
                        </Grid>
                        <Grid item md={4.5} xs={12}>
                          <FormControl sx={{ mb: 0, width: "100%" }} required>
                            <InputLabel
                              id="demo-simple-selec-label"
                              size="small"
                            >
                              Question Type
                            </InputLabel>
                            <Select
                              size="small"
                              required
                              labelId="demo-simple-selec-label"
                              id="demo-simple-select"
                              name="question_type"
                              value={inputs?.question_type}
                              label="Question Type"
                              onChange={handleChange}
                            >
                              <MenuItem value="multiple_choice">
                                Multiple Choice (single select)
                              </MenuItem>
                              <MenuItem value="multiple_select">
                                Multiple Choice (Multiple select)
                              </MenuItem>
                              <MenuItem value="free_text">Text</MenuItem>
                              <MenuItem value="text_with_link">
                                Text With Link
                              </MenuItem>
                              <MenuItem value="image">Image</MenuItem>
                              <MenuItem value="signature">Signature</MenuItem>
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item md={2} xs={12}>
                          <FormControl sx={{ mb: 0, width: "100%" }} required>
                            <InputLabel
                              id="demo-simple-selec-label1"
                              size="small"
                            >
                              Is it Required?
                            </InputLabel>
                            <Select
                              size="small"
                              required
                              labelId="demo-simple-selec-label1"
                              id="demo-simple-select"
                              name="question_type_required"
                              value={inputs?.question_type_required}
                              label="Is it Required"
                              onChange={handleChange}
                            >
                              <MenuItem value={true}>Yes</MenuItem>
                              <MenuItem value={false}>No</MenuItem>
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item md={12} xs={12} sx={{ mb: 1 }}>
                          <hr className="mb-0 " />
                        </Grid>
                        {inputs?.question_type == "multiple_choice" ? (
                          <MultipleChoiceOptions
                            answerGeniusTitle={answerGeniusTitle}
                            handleChangeAnswerGenius={handleChangeAnswerGenius}
                            answerGenius={answerGenius}
                            multipleChoiceOptions={multipleChoiceOptions}
                            handleChangeInMultipleChoice={
                              handleChangeInMultipleChoice
                            }
                            handelAddChoice={handelAddChoice}
                            handelDelChoice={handelDelChoice}
                          />
                        ) : inputs?.question_type == "multiple_select" ? (
                          <MultipleChoiceOptions
                            answerGeniusTitle={answerGeniusTitle}
                            handleChangeAnswerGenius={handleChangeAnswerGenius}
                            answerGenius={answerGenius}
                            multipleChoiceOptions={multipleChoiceOptions}
                            handleChangeInMultipleChoice={
                              handleChangeInMultipleChoice
                            }
                            handelAddChoice={handelAddChoice}
                            handelDelChoice={handelDelChoice}
                          />
                        ) : inputs?.question_type == "image" ? (
                          <ImageView rating={rating} setRating={setRating} />
                        ) : inputs?.question_type == "signature" ? (
                          <Grid item md={12} xs={12}>
                            <TextField
                              id="outlined-multiline-static"
                              multiline
                              disabled
                              rows={6}
                              sx={{
                                width: "100%",
                                "& fieldset": {
                                  top: 0,
                                },
                                "& legend": {
                                  display: "none",
                                },
                              }}
                            />
                          </Grid>
                        ) : inputs?.question_type == "text_with_link" ? (
                          <>
                            <Grid item md={6}>
                              <TextField
                                id="outlined-basic"
                                label="Button Text"
                                variant="outlined"
                                sx={{ width: "100%" }}
                                required
                                name="button_text"
                                value={inputs.button_text}
                                onChange={handleChange}
                              />
                            </Grid>
                            <Grid item md={6}>
                              <TextField
                                id="outlined-basic"
                                label="Button Link"
                                variant="outlined"
                                sx={{ width: "100%" }}
                                required
                                type="url"
                                name="button_link"
                                value={inputs.button_link}
                                onChange={handleChange}
                              />
                            </Grid>
                            <Grid item md={12} xs={12}>
                              <TextField
                                id="outlined-multiline-static"
                                label="Answer"
                                multiline
                                disabled
                                rows={6}
                                sx={{ width: "100%" }}
                              />
                            </Grid>
                          </>
                        ) : (
                          <Grid item md={12} xs={12}>
                            <TextField
                              id="outlined-multiline-static"
                              label="Answer"
                              multiline
                              disabled
                              rows={6}
                              sx={{ width: "100%" }}
                            />
                          </Grid>
                        )}
                        <Grid item md={12} xs={12}>
                          <hr className="m-0 " />
                        </Grid>
                      </Grid>
                      <div className="col-12 mt-3 text-end">
                        <Button
                          sx={{
                            mr: 1,
                          }}
                          variant="contained"
                          type="submit"
                          startIcon={<Icon icon="eva:plus-fill" />}
                        >
                          Save
                        </Button>
                        <Button
                          type="button"
                          variant="contained"
                          startIcon={
                            <Icon icon="ic:twotone-close-fullscreen" />
                          }
                          onClick={() => handelcloseQuestionsEntry()}
                        >
                          Close
                        </Button>
                      </div>
                    </Box>
                  </form>
                </Card>
              ) : (
                saveTemplate && (
                  <div className="w-100 mt-3 text-end">
                    <Button
                      type="button"
                      variant="contained"
                      onClick={() => setSaveTemplate(false)}
                      sx={{
                        mr: 1,
                      }}
                      startIcon={<Icon icon="eva:plus-fill" />}
                    >
                      Add Question
                    </Button>
                  </div>
                )
              )}
            </>
          )}
        </Stack>
      </>
    </div>
  );
}
